import React from 'react';

import { useTranslator } from 'tradera-lang/translate';
import ErrorContainer from './error-container';
import WarningIcon from '@tradera/blueprint/theme/icons/warning.svg?jsx';

export const GeneralError = () => {
    const { t } = useTranslator();
    return (
        <ErrorContainer data-general-error>
            <p>
                <WarningIcon className="icon icon-xl icon-dark" />
            </p>
            <h4>{t('error_somethingWentWrong')}</h4>
            <p>
                <a
                    data-general-reload
                    role="button"
                    className="btn btn-primary text-white size-paris"
                    href={window.location.href}>
                    {t('error_reloadPage')}
                </a>
            </p>
        </ErrorContainer>
    );
};
